import { Text } from '@bechtel/gds';
import { ReactNode } from 'react';
import { MultiLingualText } from '~/components/atoms';
import { LegendStyled, StatsColorStyled, TileStyled } from './styled';

interface TileProps<T> {
  label: string;
  labelKey: string | null;
  value: T;
  legendColor?: string;
  selected?: boolean;
  clickable?: boolean;
  clickHandler?: (label) => void;
}

export function Tile({
  label,
  labelKey,
  value,
  legendColor,
  selected = false,
  clickHandler = () => {},
  clickable = true,
}: TileProps<ReactNode>) {
  return (
    <TileStyled selected={clickable && selected} onClick={() => clickHandler(labelKey)}>
      <LegendStyled>
        <Text size="600" weight="600">
          {value}
        </Text>
        {legendColor && <StatsColorStyled color={legendColor} />}
      </LegendStyled>
      <MultiLingualText size="300" color="grey.800">
        {label}
      </MultiLingualText>
    </TileStyled>
  );
}
